/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Role_Claimant_DriverInputs */

const en_case_chat_role_claimant_driver = /** @type {(inputs: Case_Chat_Role_Claimant_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant driver`)
};

const pt_br2_case_chat_role_claimant_driver = /** @type {(inputs: Case_Chat_Role_Claimant_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condutor do requerente`)
};

/**
* | output |
* | --- |
* | "Claimant driver" |
*
* @param {Case_Chat_Role_Claimant_DriverInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_role_claimant_driver = /** @type {((inputs?: Case_Chat_Role_Claimant_DriverInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Role_Claimant_DriverInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_role_claimant_driver(inputs)
	return pt_br2_case_chat_role_claimant_driver(inputs)
});